(function () {
  'use strict';

  var ENDPOINT = 'https://www.paytr.com/odeme/taksit-tablosu/v2';
  var MOUNT_ID = 'paytr_taksit_tablosu';

  // Dawn varyant değiştirdiğinde adres çubuğunu history.replaceState ile
  // günceller ama bu bir olay yaymaz. Tek seferlik yama ile kendi olayımızı
  // yayıyoruz, böylece hangi varyant seçicisi kullanılırsa kullanılsın
  // değişimi yakalayabiliyoruz.
  if (!window.__kgLocationPatched) {
    window.__kgLocationPatched = true;
    ['pushState', 'replaceState'].forEach(function (method) {
      var original = history[method];
      if (typeof original !== 'function') return;
      history[method] = function () {
        var result = original.apply(this, arguments);
        try {
          window.dispatchEvent(new Event('kg:locationchange'));
        } catch (e) {}
        return result;
      };
    });
  }

  function init(root) {
    if (!root || root.dataset.kgInit === '1') return;
    root.dataset.kgInit = '1';

    var header = root.querySelector('[data-kg-taksit-header]');
    var body = root.querySelector('[data-kg-taksit-body]');
    var mount = root.querySelector('#' + MOUNT_ID);
    var dataEl = root.querySelector('[data-kg-taksit-prices]');

    if (!mount || !dataEl) return;

    var prices;
    try {
      prices = JSON.parse(dataEl.textContent) || {};
    } catch (e) {
      root.remove();
      return;
    }

    var token = root.dataset.token;
    var merchant = root.dataset.merchant;
    if (!token || !merchant) {
      root.remove();
      return;
    }

    var lastAmount = null;
    var timer = null;

    function currentVariantId() {
      try {
        var fromUrl = new URLSearchParams(window.location.search).get('variant');
        if (fromUrl && prices[fromUrl] != null) return fromUrl;
      } catch (e) {}
      return root.dataset.selected;
    }

    // Fiyat Liquid'den kuruş cinsinden geliyor. Burada 2 ondalıklı biçime
    // çeviriyoruz, PayTR bu biçimi (örn. 12207.66) sorunsuz kabul ediyor.
    function amountFor(id) {
      var kurus = prices[id];
      if (kurus == null) return null;
      return (Number(kurus) / 100).toFixed(2);
    }

    function setState(state) {
      root.classList.remove('is-loading', 'is-ready', 'is-failed');
      root.classList.add(state);
    }

    function render() {
      var amount = amountFor(currentVariantId());
      if (!amount) return;
      if (amount === lastAmount) return;
      lastAmount = amount;

      setState('is-loading');
      mount.innerHTML = '';

      var previous = root.querySelector('script[data-kg-taksit-script]');
      if (previous) previous.remove();

      var script = document.createElement('script');
      script.setAttribute('data-kg-taksit-script', '');
      script.async = true;
      script.src =
        ENDPOINT +
        '?token=' + encodeURIComponent(token) +
        '&merchant_id=' + encodeURIComponent(merchant) +
        '&amount=' + encodeURIComponent(amount) +
        '&taksit=' + encodeURIComponent(root.dataset.taksit || '0') +
        '&tumu=' + encodeURIComponent(root.dataset.tumu || '0');

      script.onload = function () {
        if (mount.innerHTML.trim() === '') {
          setState('is-failed');
        } else {
          setState('is-ready');
        }
      };

      script.onerror = function () {
        setState('is-failed');
      };

      root.appendChild(script);
    }

    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(render, 160);
    }

    if (header && body) {
      header.addEventListener('click', function () {
        var open = header.getAttribute('aria-expanded') === 'true';
        header.setAttribute('aria-expanded', String(!open));
        body.classList.toggle('kg-taksit__body--closed', open);
      });
    }

    window.addEventListener('kg:locationchange', schedule);
    window.addEventListener('popstate', schedule);

    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) form.addEventListener('change', schedule);

    render();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-kg-taksit]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  // Tema düzenleyicide bölüm yeniden çizildiğinde
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();